<template>
	<div class="print-designer">
		<!-- 左侧组件库 -->
		<div class="designer-left">
			<h3>📦 打印内容</h3>
			<div class="ep-draggable-item" tid="defaultModule.name" title="商品名">📄 商品名</div>
			<div class="ep-draggable-item" tid="defaultModule.unit" title="计量单位">📄 计量单位</div>
			<div class="ep-draggable-item" tid="defaultModule.format" title="规格">📄 规格</div>
			<div class="ep-draggable-item" tid="defaultModule.retailPrice" title="零售价">📄 零售价</div>
			<div class="ep-draggable-item" tid="defaultModule.wholesalePricePrice" title="批发价">📄 批发价</div>
			<div class="ep-draggable-item" tid="defaultModule.intoPrice" title="采购价">📄 采购价</div>
			<div class="ep-draggable-item" tid="defaultModule.note" title="备注">📄 备注</div>
			<div class="ep-draggable-item" tid="defaultModule.barcode" title="商品条码">📊 商品条码</div>
			<div class="ep-draggable-item" tid="defaultModule.hline" title="横线">📏 横线</div>
			<div class="ep-draggable-item" tid="defaultModule.vline" title="竖线">📏 竖线</div>
		</div>

		<!-- 中间设计区 -->
		<div class="designer-center">
			<div class="toolbar">
				<!-- 纸张尺寸区域 -->
				<div class="tool-group paper-group">
					<span class="group-label">📄 纸张尺寸</span>
					<div class="size-buttons">
						<button @click="setPaperSize(210, 297)" :class="{ active: isActiveSize(210, 297) }">A4</button>
						<button @click="setPaperSize(297, 420)" :class="{ active: isActiveSize(297, 420) }">A3</button>
						<button @click="setPaperSize(148, 210)" :class="{ active: isActiveSize(148, 210) }">A5</button>
						<button @click="setPaperSize(176, 250)" :class="{ active: isActiveSize(176, 250) }">B5</button>
						<button @click="setPaperSize(216, 279)" :class="{ active: isActiveSize(216, 279) }">Letter</button>
						<button @click="setPaperSize(241, 280)" :class="{ active: isActiveSize(241, 280) }">送货单(241x280)</button>
						<button @click="setPaperSize(241, 140)" :class="{ active: isActiveSize(241, 140) }">快递单(241x140)</button>
						<button @click="setPaperSize(50, 35)" :class="{ active: isActiveSize(50, 35) }">条码(50x35)</button>
					</div>
					<div class="custom-size">
						<input type="number" v-model.number="customWidth" placeholder="宽度(mm)" step="1" min="1">
						<span> x </span>
						<input type="number" v-model.number="customHeight" placeholder="高度(mm)" step="1" min="1">
						<button @click="applyCustomSize">应用</button>
					</div>
				</div>

				<!-- 模板管理区域 -->
				<div class="tool-group template-group">
					<span class="group-label">🗂️ 模板管理</span>
					<div class="template-controls">
						<input type="text" v-model="templateName" placeholder="模板名称" class="template-name-input">
						<select v-model="selectedTemplateId" @change="loadSelectedTemplate" class="template-select">
							<option value="">-- 选择 --</option>
							<option v-for="tpl in templateList" :key="tpl.id" :value="tpl.id">
								{{tpl.name}}
							</option>
						</select>
						<button @click="saveTemplateToDb" class="btn-db-save">💾 保存</button>
						<button @click="deleteTemplate" v-if="selectedTemplateId" class="btn-db-delete">🗑️ 删除</button>
					</div>
				</div>

				<!-- 操作按钮区域 -->
				<div class="tool-group action-group">
					<span class="group-label">⚡ 操作</span>
					<div class="action-buttons">
						<button @click="saveTemplate">💾 选择模版</button>
						<button @click="printPreview">🖨️ 打印预览</button>
						<button @click="clearAllElements" class="danger">🗑️ 清空内容</button>
						<button @click="rotatePaper" class="rotate">🔄 旋转纸张</button>
					</div>
				</div>
			</div>
			<!-- 分页容器 -->
			<!-- <div class="hiprint-printPagination"></div> -->
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>

		<!-- 右侧属性面板 -->
		<div class="designer-right">
			<h3>⚙️ 属性设置</h3>
			<div id="PrintElementOptionSetting"></div>
		</div>
	</div>
</template>

<script>
	// 脚本部分完全保持不变（与您最后提供的代码一致）
	import {
		hiprint,
		defaultElementTypeProvider,
		disAutoConnect
	} from 'vue-plugin-hiprint'
	import request from '@/utils/request'
	import addElementTypes from '@/utils/addElementTypes'
	export default {
		name: 'PrintCodePage',
		data() {
			return {
				hiprintTemplate: null,
				customWidth: 210,
				customHeight: 297,
				currentWidth: 210,
				currentHeight: 297,
				templateName: '',
				selectedTemplateId: '',
				templateList: [],
				printType:'printCode'
			}
		},
		mounted() {
			this.$nextTick(() => {
				const saved = localStorage.getItem('printCodeTemplate')
				let templateJson = null;
				if (saved) {
					templateJson = JSON.parse(saved);
				}
				this.initDesigner(templateJson)
				this.fetchTemplates()
			})
		},
		beforeDestroy() {
		},
		watch:{
			'$route.query.printType': {
				immediate: true,
				handler(param) {
					if (param) {
						this.printType = param;
					}
				}
			},
		},
		methods: {
			initDesigner(json) {
				if(json){
					this.currentWidth = json.panels[0].width;
					this.currentHeight = json.panels[0].height;
					this.customWidth = json.panels[0].width;
					this.customHeight = json.panels[0].height;
				}
				disAutoConnect()
				if (!window.$) {
					console.error('❌ jQuery 未加载')
					return
				}
				try {
					const provider = new addElementTypes()
					hiprint.init({
						providers: [provider]
					})
					console.log('✅ hiprint.init 成功')

					const $items = $('.ep-draggable-item')
					if ($items.length === 0) {
						console.warn('⚠️ 未找到 .ep-draggable-item 元素')
						return
					}
					hiprint.PrintElementTypeManager.buildByHtml($items)
					console.log(`✅ 已构建 ${$items.length} 个可拖拽组件`)
					$("#hiprint-printTemplate").empty(); // 先清空, 避免重复构建
					this.hiprintTemplate = new hiprint.PrintTemplate({
						template: json ? json : {},
						settingContainer: '#PrintElementOptionSetting',
						paginationContainer: '.hiprint-printPagination',
						fontList: [{
								title: '微软雅黑',
								value: 'Microsoft YaHei'
							},
							{
								title: '宋体',
								value: 'SimSun'
							},
							{
								title: '黑体',
								value: 'SimHei'
							}
						],
						onDataChanged: (type, json) => {
							console.log('📝 模板已变更', type, json)
						}
					})
					if(!json){
						// 添加默认面板
						this.hiprintTemplate.addPrintPanel({
							width: this.currentWidth,
							height: this.currentHeight,
							paperHeader: 0,
							paperFooter: 0
						})
					}
					this.hiprintTemplate.design('#hiprint-printTemplate')
					console.log('✅ 设计器渲染完成')
				} catch (error) {
					console.error('❌ 初始化失败:', error)
				}
			},
			checkPaperHeight() {
				if (!this.hiprintTemplate) return;
				const json = this.hiprintTemplate.getJson();
				const panel = json.panels[0];
				if (!panel) {
					console.warn('没有面板');
					return;
				}
				const paperHeightPt = panel.height * 2.83465;
				const maxBottom = panel.elements.reduce((max, el) => {
					const bottom = (el.options.top || 0) + (el.options.height || 0);
					return Math.max(max, bottom);
				}, 0);
				console.log('纸张高度(pt):', paperHeightPt);
				console.log('元素最大底部(pt):', maxBottom);
				if (maxBottom > paperHeightPt) {
					console.warn('内容超出纸张，超出高度:', (maxBottom - paperHeightPt).toFixed(2), 'pt');
					console.warn('建议增加纸张高度或上移/缩小元素');
				} else {
					console.log('✅ 所有元素都在一页内');
				}
			},
			setPaperSize(width, height) {
				if (!this.hiprintTemplate) return
				try {
					this.hiprintTemplate.setPaper(width, height)
					this.currentWidth = width
					this.currentHeight = height
					this.customWidth = width
					this.customHeight = height
					console.log(`✅ 纸张尺寸已更改为 ${width}mm x ${height}mm`)
				} catch (error) {
					console.error('❌ 更改纸张尺寸失败:', error)
				}
			},
			applyCustomSize() {
				if (this.customWidth > 0 && this.customHeight > 0) {
					this.setPaperSize(this.customWidth, this.customHeight)
				} else {
					alert('请输入有效的宽度和高度（正整数）')
				}
			},
			isActiveSize(width, height) {
				return this.currentWidth === width && this.currentHeight === height
			},
			saveTemplate() {
				if (!this.hiprintTemplate) return
				const json = this.hiprintTemplate.getJson()
				console.log('📦 模板 JSON:', json)
				localStorage.setItem('printCodeTemplate', JSON.stringify(json))
				alert('模板已保存到 localStorage')
			},
			async fetchTemplates() {
				try {
					const res = await request.get(`/api/PrintTemplate/GetAll?printType=${this.printType}`)
					this.templateList = res.data
				} catch (error) {
					console.error('获取模板列表失败:', error)
				}
			},
			async saveTemplateToDb() {
				if (!this.hiprintTemplate) return
				if (!this.templateName.trim()) {
					alert('请输入模板名称')
					return
				}
				const json = this.hiprintTemplate.getJson()
				try {
					await request.post('/api/PrintTemplate/Create', {
						name: this.templateName,
						jsonContent: JSON.stringify(json),
						printType : this.printType
					})
					alert('模板保存成功')
					this.templateName = ''
					this.fetchTemplates()
				} catch (error) {
					console.error('保存模板失败:', error)
					alert('保存失败，请检查网络或后端服务')
				}
			},
			async loadSelectedTemplate() {
				if (!this.selectedTemplateId) return
				try {
					const res = await request.get(`/api/PrintTemplate/GetById?id=${this.selectedTemplateId}`)
					const templateJson = JSON.parse(res.data.jsonContent)
					this.initDesigner(templateJson)
					console.log('✅ 模板加载成功')
				} catch (error) {
					console.error('加载模板失败:', error)
					alert('加载模板失败')
				}
			},
			async deleteTemplate() {
				if (!this.selectedTemplateId) return
				if (!confirm('确定删除该模板吗？')) return
				try {
					await request.delete(`/api/PrintTemplate/Delete?id=${this.selectedTemplateId}`)
					alert('删除成功')
					this.selectedTemplateId = ''
					this.fetchTemplates()
				} catch (error) {
					console.error('删除模板失败:', error)
					alert('删除失败')
				}
			},
			clearAllElements() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.clear()
				console.log('✅ 已清空所有元素')
			},
			rotatePaper() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.rotatePaper()
				const newWidth = this.currentHeight
				const newHeight = this.currentWidth
				this.currentWidth = newWidth
				this.currentHeight = newHeight
				this.customWidth = newWidth
				this.customHeight = newHeight
				console.log(`✅ 纸张已旋转，新尺寸: ${newWidth}mm x ${newHeight}mm`)
			},
			printPreview() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.print()
			},
			printDirect() {
				this.checkPaperHeight();
			}
		}
	}
</script>

<style scoped>
	/* ========== 整体布局（不变） ========== */
	.print-designer {
		display: flex;
		height: 100vh;
		font-family: 'Microsoft YaHei', sans-serif;
		border: 1px solid #e8e8e8;
	}

	.designer-left {
		width: 200px;
		flex-shrink: 0;
		border-right: 1px solid #ddd;
		padding: 12px;
		background-color: #f8f9fa;
		overflow-y: auto;
	}

	.designer-left h3 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 16px;
		text-align: center;
		color: #333;
	}

	.ep-draggable-item {
		padding: 8px 12px;
		margin-bottom: 8px;
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		cursor: move;
		user-select: none;
		transition: all 0.2s;
		font-size: 14px;
	}

	.ep-draggable-item:hover {
		background-color: #e6f7ff;
		border-color: #1890ff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.designer-center {
		flex: 1;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		overflow: hidden;
		min-width: 0;
	}

	/* ========== 紧凑型工具栏样式 ========== */
	.toolbar {
		padding: 8px 12px;
		border-bottom: 1px solid #e9ecef;
		background-color: #fafbfc;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		align-items: flex-start;
		flex-shrink: 0;
	}

	.tool-group {
		background: #ffffff;
		border-radius: 8px;
		padding: 6px 12px;
		border: 1px solid #eef2f6;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
	}

	.group-label {
		display: block;
		font-size: 11px;
		font-weight: 600;
		color: #1e2a3a;
		margin-bottom: 5px;
		letter-spacing: 0.3px;
		border-left: 3px solid #1890ff;
		padding-left: 6px;
	}

	.size-buttons {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-bottom: 6px;
	}

	.custom-size {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: wrap;
		margin-top: 6px;
		padding-top: 5px;
		border-top: 1px dashed #e2e8f0;
	}

	.template-controls {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;
	}

	.action-buttons {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	/* 按钮紧凑样式 */
	.toolbar button {
		padding: 4px 10px;
		border: 1px solid #d0d5dd;
		border-radius: 16px;
		background-color: #fff;
		cursor: pointer;
		font-size: 12px;
		font-weight: 500;
		transition: all 0.2s ease;
		color: #1f2937;
		box-shadow: 0 1px 1px rgba(0,0,0,0.02);
	}

	.toolbar button:hover {
		background-color: #f3f4f6;
		border-color: #9ca3af;
		transform: translateY(-1px);
	}

	.toolbar button.active {
		background-color: #1890ff;
		color: #fff;
		border-color: #1890ff;
		box-shadow: 0 2px 6px rgba(24,144,255,0.2);
	}

	.toolbar button.danger:hover {
		background-color: #fee2e2;
		border-color: #f87171;
		color: #b91c1c;
	}

	.toolbar button.rotate:hover {
		background-color: #e6f7e6;
		border-color: #52c41a;
		color: #2e7d32;
	}

	.toolbar button.btn-db-save:hover {
		background-color: #fff7e6;
		border-color: #faad14;
		color: #ad6800;
	}

	.toolbar button.btn-db-delete:hover {
		background-color: #ffe7e7;
		border-color: #ff4d4f;
		color: #cf1322;
	}

	.custom-size input,
	.template-name-input {
		width: 90px;
		padding: 4px 8px;
		border: 1px solid #d1d5db;
		border-radius: 16px;
		font-size: 12px;
		text-align: center;
		transition: border 0.2s;
		background-color: #fff;
	}

	.custom-size input:focus,
	.template-name-input:focus,
	.template-select:focus {
		outline: none;
		border-color: #1890ff;
		box-shadow: 0 0 0 2px rgba(24,144,255,0.1);
	}

	.template-select {
		padding: 4px 8px;
		border: 1px solid #d1d5db;
		border-radius: 16px;
		font-size: 12px;
		background-color: #fff;
		cursor: pointer;
		width: 100px;
	}

	.custom-size span {
		font-size: 12px;
		color: #6b7280;
	}

	/* 分页容器 */
	.hiprint-printPagination {
		background-color: #fafbfc;
		border-top: 1px solid #edf2f7;
		border-bottom: 1px solid #edf2f7;
		padding: 6px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		flex-wrap: wrap;
		font-size: 13px;
		flex-shrink: 0;
	}

	/* 画布容器 */
	.designer-canvas {
		flex: 1;
		overflow: auto;
		padding: 20px;
		background-color: #f0f2f5;
		min-height: 0;
	}

	/* 右侧面板 */
	.designer-right {
		width: 300px;
		flex-shrink: 0;
		border-left: 1px solid #ddd;
		padding: 12px;
		background-color: #f8f9fa;
		overflow-y: auto;
	}

	.designer-right h3 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 16px;
		text-align: center;
		color: #333;
	}
</style>